<template>
  <b-modal ref="cancelConfirmation" :id=modalId title="Cancel">
      Any changes you have made to this form will be lost.  Are you sure you want to cancel?
      <div slot="modal-footer">
        <b-button variant="danger" class="button-row-spacing" @click="hideModal">
          No
        </b-button>
        <b-button @click="onCancel()">
          Yes
        </b-button>
      </div>
    </b-modal>
</template>
<script>
export default {
  name: 'CancelModal',
  components: {
  },
  props: [
    'modalId',
  ],
  methods: {
    hideModal() {
      this.$refs.cancelConfirmation.hide();
    },
    onCancel() {
      this.$emit('cancelled');
    },
  },
};
</script>
